export default "__VITE_ASSET__ee920569__"